<template>
<div class="dataPanelConfig">
  <el-form class="select-panel-form" :inline="true" ref="form" :model="selectForm" label-width="80px">
    <div>
      <el-form-item>
        <el-select v-model="panelId" placeholder="请选择面板" size="mini" filterable clearable @change="changePanel()" @clear="addPanel">
          <el-option v-for="item in panelOptions" :key="item.panelId" :label="item.panelName" :value="item.panelId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="addPanel">新增面板</el-button>
      </el-form-item>
    </div>
  </el-form>
  <el-form :inline="true" ref="form" label-width="80px">
    <el-form-item>
      <el-select v-model="sceneId" placeholder="请选择场景" size="mini" filterable clearable>
        <el-option v-for="item in sceneOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item style="margin-left: 50px;">
      <el-button type="text" @click="panelThumbnailBtn()">选择面板缩略图</el-button>
    </el-form-item> -->
    <!-- <el-form-item>
      <a href="javascript:;" class="a-upload">
        <input type="file" name="" id="" ref="myInput" @change="getFile($event)">
      </a>
    </el-form-item> -->
  </el-form>
  <div class="panel-form">
    <el-form v-for="(form, index) in paramDTOS" :key="index" :inline="true" ref="form" :model="form" label-width="80px">
      <div class="row" v-if="index === 0">
        <el-form-item>
          <el-input placeholder="请输入面板名称" v-model="panelName" size="mini" class="select-width"></el-input>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button v-if="index == 0" @click="addMotherBoadr(index)" type="primary" size="mini">添加母版</el-button>
      </el-form-item>
      <div class="block-config">
        <div class="row">
          <el-form-item>
            <el-select :value="form.type" placeholder="请选择母版" size="mini" class="select-width" @change="res => changeMother(res, index)">
              <el-option v-for="item in motherboadrOptions" :key="item.type" :label="item.label" :value="item.type"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item>
            <el-button @click="addMotherBoadr(index)" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
          </el-form-item> -->
          <el-form-item v-if="form.type != 2">
            <el-button type="primary" @click="addFormData(index)" size="mini">添加配置</el-button>
          </el-form-item>
          <el-form-item v-if="index > 0">
            <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="deleteMotherBoadr(index)"></el-button>
          </el-form-item>
        </div>
        <div class="s1" v-if="form.type == 1">
          <div class="row">
            <div v-for="(item, formIndex) in form.formObjects" :key="formIndex">
              <el-form-item>
                <el-input placeholder="表单字段中文名称" size="mini" v-model="item.name" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="占位编号" size="mini" v-model="item.placeholder"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="单位" size="mini" v-model="item.unit" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addFormData(index)"></el-button>
                <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="delFormData(index, 'formObjects', formIndex)"></el-button>
                <!-- <el-button type="primary" size="mini" circle @click="addStatusMap(index, formIndex)">数</el-button> -->
              </el-form-item>
              <div class="row" v-if="item.hasOwnProperty('statusMap')">
                <div class="title">数字量状态列表</div>
                <div>
                  <el-table :data="item.statusMap" style="width: 100%">
                    <el-table-column fixed prop="number" label="信息量数字" width="200">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.number" placeholder="请输入信息量数字"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="显示中文">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.name" placeholder="请输入中文名称"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="color" label="颜色" width="180">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.color" placeholder="请输入颜色值"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="180">
                      <template slot-scope="scope">
                        <el-button type="text" size="small" icon="el-icon-plus" circle @click="addTableData(index, formIndex)"></el-button>
                        <el-button type="text" size="small" icon="el-icon-minus" circle @click="delTableData(index, formIndex, scope.$index)"></el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="s2" v-if="form.type == 2">
          <div class="row" v-for="(item, formIndex) in form.listObjects" :key="formIndex">
            <div>
              <el-form-item>
                <el-input v-model="headerTitle" placeholder="列头名称" size="mini" class="input-width"></el-input>
              </el-form-item>
              <el-form-item v-for="(title, colIndex) in item.titles" :key="colIndex">
                <el-input v-model="item.titles[colIndex]" placeholder="列头名称" size="mini" class="input-width"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addCol(index, formIndex)"></el-button>
                <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="delCol(index, formIndex)"></el-button>
                <el-button type="primary" size="mini" circle @click="addGroup(index, formIndex)">组</el-button>
              </el-form-item>
            </div>
            <div v-for="(row, rowIndex) in item.columns" :key="rowIndex">
              <el-form-item>
                <el-input :disabled="item.titles.length < 1" placeholder="行头名称" size="mini" class="input-width" v-model="item.columns[rowIndex].key"></el-input>
              </el-form-item>
              <el-form-item v-for="(bit, bitIndex) in item.titles" :key="bitIndex">
                <el-input placeholder="占位编号" v-model="item.columns[rowIndex]['val'][bitIndex]" size="mini" class="input-width"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addRow(index, formIndex)"></el-button>
                <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="delRow(index, formIndex, rowIndex)"></el-button>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="s3" v-if="form.type == 3">
          <div class="row">
            <div v-for="(item, formIndex) in form.picObjects" :key="formIndex">
              <el-form-item>
                <el-input placeholder="表单字段中文名称" size="mini" v-model="item.name" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="占位编号" size="mini" v-model="item.placeholder" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="单位" size="mini" v-model="item.unit" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addFormData(index)"></el-button>
                <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="delFormData(index, 'picObjects', formIndex)"></el-button>
                <el-button type="primary" size="mini" circle @click="addStatusMap(index, formIndex)">数</el-button>
              </el-form-item>
              <div class="row" v-if="item.hasOwnProperty('statusMap')">
                <div class="title">数字量状态列表</div>
                <div>
                  <el-table :data="item.statusMap" style="width: 100%">
                    <el-table-column fixed prop="number" label="信息量数字" width="200">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.number" placeholder="请输入信息量数字"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="显示中文">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.name" placeholder="请输入中文名称"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="color" label="颜色" width="180">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.color" placeholder="请输入颜色值"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="180">
                      <template slot-scope="scope">
                        <el-button type="text" size="small" icon="el-icon-plus" circle @click="addTableData(index, formIndex)"></el-button>
                        <el-button type="text" size="small" icon="el-icon-minus" circle @click="delTableData(index, formIndex, scope.$index)"></el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="s4" v-if="form.type == 4">
          <div class="row">
            <div v-for="(item, formIndex) in form.chartObjects" :key="formIndex" style="border: 1px solid #ddd;border-radius: 4px;margin-bottom: 5px;padding: 10px 0px 0px 10px;">
              <el-form-item>
                <el-input placeholder="y坐标轴数值名称" size="mini" v-model="item.name" clearable></el-input>
              </el-form-item>
              <div class="row">
                <div class="title">y坐标轴集合</div>
                <div v-for="(item1, formIndex1) in item.series" :key="formIndex1">
                  <el-form-item>
                    <el-input placeholder="y坐标轴集合名称" size="mini" v-model="item1.name" clearable></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input placeholder="占位编号" size="mini" v-model="item1.y_placeholder" clearable></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addFormData(index)"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="delFormData(index, 'chartObjects', formIndex)"></el-button>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div class="publishBtn">
      <el-button type="primary" size="mini" class="button-width" @click="publish">发布</el-button>
    </div>
  </div>
  <el-dialog title="选择面板缩略图" :visible.sync="isPanelThumbnailDialog" :modal-append-to-body="false">
    <div class="centerPic">
      <el-carousel indicator-position="outside" :autoplay="false" ref="carousel" trigger="click">
        <el-carousel-item v-for="(item, index) in centerImgs" :key="index" name="index">
          <p style="font-size: 18px;font-weight: 600;margin-bottom: 20px;">{{item.title}}</p>
          <img :src="item.src" alt="" style="width: 500px;">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="footer" style="text-align: center;">
      <el-button type="primary" @click="onSubmit()">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {
  getInfo
} from '@/utils/auth';
import API from '@/api/dataPanelConfig';
export default {
  components: {},
  data() {
    return {
      selectForm: {},
      panelId: '',
      panelName: '',
      paramDTOS: [{
        type: 1
      }, {
        type: 2
      }, {
        type: 3
      }, {
        type: 4
      }],
      panelOptions: [],
      sceneId: '',
      sceneOptions: [{
        id: 0,
        name: '储能'
      }, {
        id: 1,
        name: '光伏'
      }, {
        id: 2,
        name: '负载'
      }, {
        id: 3,
        name: '充电桩'
      }, {
        id: 4,
        name: '并网点'
      }, {
        id: 5,
        name: '场景图'
      }],
      motherboadrOptions: [{
        type: 1,
        label: '表单母版'
      }, {
        type: 2,
        label: '列表母版'
      }, {
        type: 3,
        label: '图标母版'
      }, {
        type: 4,
        label: '折线或柱图母版'
      }],
      activeName: 'first',
      tableData: [],
      headerTitle: '列头名称',
      listObjects: [{
        columns: [{
          key: '',
          val: []
        }],
        titles: []
      }],
      isPanelThumbnailDialog: false,
      centerImgs: [{
        id: 120005,
        title: '3个场景(并网点、储能、负载)',
        src: "../../../../static/images/boss/module1.png"
      }, {
        id: 120006,
        title: '4个场景(光伏、储能、负载、并网点)',
        src: "../../../../static/images/boss/module2.png"
      }],
      activeIndex: 0
    };
  },
  watch: {},
  created() {
    this.init();
  },
  methods: {
    //初始化
    init() {
      this.paramDTOS = [{}];
      this.searchAllPanelTemplate();
    },
    //获取全部模板
    searchAllPanelTemplate() {
      API.searchAllPanelTemplate().then(res => {
        if (res.data.code == 200) {
          this.panelOptions = res.data.data;
        }
      });
    },
    //切换面板
    changePanel() {
      let params = {
        id: this.panelId
      };
      API.searchPanelTemplateById(params).then(res => {
        if (res.data.code == 200) {
          this.panelOptions.forEach(item => {
            if (item.panelId == this.panelId) {
              this.sceneId = item.scene;
              this.panelName = item.panelName;
            }
          });
          let item = res.data.data;
          let tmpItem = [];
          if (item.formObjects) {
            let obj = {
              type: 1,
              formObjects: item.formObjects
            };
            tmpItem.push(obj);
            item.formObjects.forEach((item1, index) => {
              if (item1.statusMap) {
                let statusMap = [];
                for (var key in item1.statusMap) {
                  item1.statusMap[key].number = key;
                  statusMap.push(item1.statusMap[key]);
                }
                it.formObjects[index].statusMap = statusMap;
              }
            });
          }
          if (item.listObjects) {
            let obj = {
              type: 2,
              listObjects: item.listObjects
            };
            tmpItem.push(obj);
            item.listObjects.forEach((item, index) => {
              //解析columns
              if (item.columns) {
                let statusMap = [];
                for (var key in item.columns) {
                  statusMap.push({
                    key: key,
                    val: item.columns[key]
                  });
                }
                it.listObjects[index].columns = statusMap;
              }
            });
          }
          if (item.picObjects) {
            let obj = {
              type: 3,
              picObjects: item.picObjects
            };
            tmpItem.push(obj);
            item.picObjects.forEach((item2, index2) => {
              if (item2.statusMap) {
                let statusMap = [];
                for (var key in item2.statusMap) {
                  item2.statusMap[key].number = key;
                  statusMap.push(item2.statusMap[key]);
                }
                it.picObjects[index2].statusMap = statusMap;
              }
            });
          }
          if (item.chartObjects) {
            let obj = {
              type: 4,
              chartObjects: item.chartObjects
            };
            tmpItem.push(obj);
            item.chartObjects.forEach((item3, index3) => {
              if (item3.statusMap) {
                let statusMap = [];
                for (var key in item3.statusMap) {
                  item3.statusMap[key].number = key;
                  statusMap.push(item3.statusMap[key]);
                }
                it.chartObjects[index3].statusMap = statusMap;
              }
            });
          }
          this.paramDTOS = tmpItem;
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
          this.sort();
        }
      });
    },
    panelThumbnailBtn() {
      this.isPanelThumbnailDialog = true;
    },
    onSubmit() {
      let activeIndex = this.$refs.carousel.activeIndex;
      this.activeIndex = activeIndex;
    },
    getFile(e) {
      let file = e.target.files[0];
      this.importFuelCellTemplate(file);
      // this.$refs.myInput = "";
      // e.target.value = '';
    },
    importFuelCellTemplate(e) {
      // var formData = new FormData();
      // formData.append('multipartFile', e);
      // axios({
      //   headers: {
      //     'Content-Type': 'multipart/form-data;'
      //   },
      //   method: 'post',
      //   url: 'http://testapi.svoltems.cn/svoltcloudapi/hydrogenenergy/v1/import/fuelCellTemplate',
      //   data: formData
      // }).then(res => {
      //   if (res.data.code == 200) {
      //     this.$message({
      //       type: 'success',
      //       message: '导入成功！'
      //     });
      //     this.getList();
      //   } else {
      //     this.$message({
      //       type: 'error',
      //       message: '导入失败！原因：' + res.data.msg
      //     });
      //   }
      // });
    },
    //新增母版
    addMotherBoadr(index) {
      if (this.paramDTOS.length > 2) {
        this.$message.warning('每个面板最多支持3个母版！');
        return false;
      }
      if (!this.paramDTOS[index].type) {
        this.$message.warning('请选择母版类型！');
        return false;
      }
      this.paramDTOS.push({});
    },
    //删除模板
    deleteMotherBoadr(index) {
      if (this.paramDTOS[index].type) {
        this.$confirm('确认要删除此母版吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.paramDTOS.splice(index, 1);
        });
      } else {
        this.paramDTOS.splice(index, 1);
      }
    },
    //切换母版前的操作
    changeMotherBefore($even, index) {
      if ($even == true) {
        let type = this.paramDTOS[index].type;
        // console.log(type);
      }
    },
    //切换母版
    changeMother(res, index) {
      let type = res;
      // console.log(type);
      this.$confirm('此操作会清空当前数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          this.paramDTOS[index].type = type;
          if (type == 1) {
            this.paramDTOS[index].formObjects = [{
              name: '',
              placeholder: '',
              unit: ''
            }];
          } else if (type == 2) {
            this.paramDTOS[index].listObjects = [{
              columns: [{
                key: '',
                val: []
              }],
              titles: []
            }];
          } else if (type == 3) {
            this.paramDTOS[index].picObjects = [{
              name: '',
              placeholder: '',
              unit: ''
            }];
          } else if (type == 4) {
            this.paramDTOS[index].chartObjects = [{
              name: "",
              series: [{
                name: "",
                y_placeholder: 0
              }],
              xaxisType: 0
            }];
          }
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
        })
        .catch(() => {});
    },
    //增加表单字段中文名称
    addFormData(index) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        this.paramDTOS[index].formObjects.push({
          name: '',
          placeholder: '',
          unit: ''
        });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
      if (type == 3) {
        this.paramDTOS[index].picObjects.push({
          name: '',
          placeholder: '',
          unit: ''
        });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
      if (type == 4) {
        this.paramDTOS[index].chartObjects.push({
          name: "",
          series: [{
            name: "",
            y_placeholder: 0
          }],
          xaxisType: 0
        });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
      this.sort();
    },
    //删除表单字段中文名称
    delFormData(index, dataType, formIndex) {
      // console.log(index, formIndex)
      let type = this.paramDTOS[index].type;
      this.$confirm('确认要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.paramDTOS[index][dataType].splice(formIndex, 1);
      });
    },
    //增加数字量状态
    addStatusMap(index, formIndex) {
      let type = this.paramDTOS[index].type;
      // console.log(type);
      if (type == 1) {
        if (this.paramDTOS[index].formObjects[formIndex].statusMap && this.paramDTOS[index].formObjects[formIndex].statusMap.length) {
          this.$message.warning('数字量状态列表已存在！');
          return false;
        } else {
          this.paramDTOS[index].formObjects[formIndex].statusMap = [{
            number: '',
            name: '',
            color: ''
          }];
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
        }
      } else if (type == 3) {
        if (this.paramDTOS[index].picObjects[formIndex].statusMap && this.paramDTOS[index].picObjects[formIndex].statusMap.length) {
          this.$message.warning('数字量状态列表已存在！');
          return false;
        } else {
          this.paramDTOS[index].picObjects[formIndex].statusMap = [{
            number: '',
            name: '',
            color: ''
          }];
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
        }
      }
      this.sort();
    },
    //添加一行表记录
    addTableData(index, formIndex) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        this.paramDTOS[index].formObjects[formIndex].statusMap.push({
          number: '',
          name: '',
          color: ''
        });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      } else if (type == 3) {
        this.paramDTOS[index].picObjects[formIndex].statusMap.push({
          number: '',
          name: '',
          color: ''
        });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      } else if (type == 4) {
        this.paramDTOS[index].chartObjects[formIndex].statusMap.push({
          name: "",
          series: [{
            name: "",
            y_placeholder: 0
          }],
          xaxisType: 0
        });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
      this.sort();
    },
    //删除一行表记录
    delTableData(index, formIndex, rowIndex) {
      let type = this.paramDTOS[index].type;
      this.$confirm('确认要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (type == 1) {
          this.paramDTOS[index].formObjects[formIndex].statusMap.splice(rowIndex, 1);
        } else if (type == 3) {
          this.paramDTOS[index].picObjects[formIndex].statusMap.splice(rowIndex, 1);
        } else if (type == 4) {
          this.paramDTOS[index].chartObjects[formIndex].statusMap.splice(rowIndex, 1);
        }
      });
    },
    //新增面板
    addPanel() {
      if (this.panelId || this.panelName) {
        this.$confirm('是否保存当前编辑面板?', '提示', {
            confirmButtonText: '保存',
            cancelButtonText: '不保存',
            type: 'warning'
          })
          .then(() => {
            this.panelId = '';
            this.panelName = '';
            this.paramDTOS = [{}];
          })
          .catch(() => {
            this.panelId = '';
            this.panelName = '';
            this.paramDTOS = [{}];
          });
      } else {
        this.panelId = '';
        this.panelName = '';
        this.paramDTOS = [{}];
      }
    },
    /* 列表母版*/
    //加列
    addCol(index, formIndex) {
      let val = [];
      this.paramDTOS[index].listObjects[formIndex].titles.push('');
      let titles = this.paramDTOS[index].listObjects[formIndex].titles;
      titles.forEach(item => {
        val.push('');
      });
      this.paramDTOS[index].listObjects[formIndex].columns.map(item => {
        item.val = val;
      })
      this.sort();
    },
    //删列
    delCol(index, formIndex) {
      let pos = this.paramDTOS[index].listObjects[formIndex].titles.length - 1;
      this.paramDTOS[index].listObjects[formIndex].titles.splice(pos, 1);
    },
    //加行
    addRow(index, formIndex) {
      let val = [];
      let titles = this.paramDTOS[index].listObjects[formIndex].titles;
      titles.forEach(item => {
        val.push('');
      });
      this.paramDTOS[index].listObjects[formIndex].columns.push({
        key: '',
        val: val
      });
      this.sort();
    },
    //删行
    delRow(index, formIndex, rowIndex) {
      let pos = this.paramDTOS[index].listObjects[formIndex].columns.length - 1;
      if (pos > 0) {
        this.paramDTOS[index].listObjects[formIndex].columns.splice(rowIndex, 1);
      }
    },
    //加组
    addGroup(index, formIndex) {
      this.paramDTOS[index].listObjects.push({
        columns: [{
          key: '',
          val: []
        }],
        titles: []
      });
    },
    //数字排序
    sort() {
      let number = 0;
      this.paramDTOS.map(item => {
        let key = '';
        if (item.hasOwnProperty('formObjects')) {
          key = 'formObjects';
        }
        if (item.hasOwnProperty('picObjects')) {
          key = 'picObjects';
        }
        if (item.hasOwnProperty('listObjects')) {
          key = 'listObjects';
        }
        if (item.hasOwnProperty('chartObjects')) {
          key = 'chartObjects';
        }
        item[key].map(item1 => {
          if (item1.hasOwnProperty('placeholder')) {
            item1.placeholder = number;
            number++;
          }
          if (item1.hasOwnProperty('statusMap') && item1.statusMap != null) {
            item1.statusMap.map(item2 => {
              item2.number = number;
              number++;
            });
          }
          if (item1.hasOwnProperty('columns')) {
            item1.columns.map(item3 => {
              let v = [];
              for (var key in item3.val) {
                v.push(number);
                number++;
              }
              item3.val = v;
            });
          }
        });
      });
      this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
    },
    //发布面板
    publish() {
      let params = {};
      params.kind = 1; //0-3d面板配置, 1-项目监控配置
      params.panelId = this.panelId ? this.panelId : '';
      params.panelName = this.panelName;
      if (!params.panelName) {
        this.$message.warning('请输入面板名称！');
        return false;
      }
      params.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      // for (let i in this.centerImgs) {
      //   if (this.activeIndex == this.centerImgs[i].id) {
      //     params.picName = this.centerImgs[i].src;
      //   }
      // }
      params.scene = this.sceneId;
      params.paramDTOS.map(item => {
        if (item.type == 1) {
          item.formObjects.map(it => {
            if (it.hasOwnProperty('statusMap')) {
              let tmp = {};
              let key = '';
              it.statusMap.forEach(i => {
                key = i.number.toString();
                tmp[key] = {
                  name: i.name,
                  color: i.color
                };
              });
              it.statusMap = tmp;
            }
          });
        }
        if (item.type == 2) {
          item.listObjects.map(it => {
            if (it.columns.length) {
              let columns = [];
              let tmp = {};
              it.columns.forEach(i => {
                let k = i.key;
                tmp[k] = i.val;
              });
              it.columns = tmp;
            }
          });
        }
        if (item.type == 3) {
          item.picObjects.map(it => {
            if (it.statusMap == null) {
              delete it.statusMap;
            }
            if (it.hasOwnProperty('statusMap')) {
              let tmp3 = {};
              let key = '';
              it.statusMap.forEach(i => {
                key = i.number.toString();
                tmp3[key] = {
                  name: i.name,
                  color: i.color
                };
              });
              it.statusMap = tmp3;
            }
          });
        }
        if (item.type == 4) {
          item.chartObjects.map(it => {
            if (it.statusMap == null) {
              delete it.statusMap;
            }
            if (it.hasOwnProperty('statusMap')) {
              let tmp4 = {};
              let key = '';
              it.statusMap.forEach(i => {
                key = i.number.toString();
                tmp4[key] = {
                  name: i.name,
                  color: i.color
                };
              });
              it.statusMap = tmp4;
            }
          });
        }
      });
      // console.log(params)
      API.saveOrUpdatePanelTemplate(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          // this.changePanel();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dataPanelConfig {
  background: #fff;
  padding: 20px;

  .panel-form {
    height: 64vh;
    overflow-y: auto;

    .select-width {
      width: 432px;
    }

    .input-width {
      width: 80px;
    }

    .block-config {
      border: 1px solid #dcdfe6;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 20px;

      .title {
        margin: 10px 0px;
        font-weight: bold;
      }

      .row {
        margin: 5px 0px;
      }
    }
  }

  .publishBtn {
    text-align: center;

    .button-width {
      width: 90px;
    }
  }

  >>> .el-carousel__container {
    height: 2.4rem;
  }

  .centerPic {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/template/dataPanelConfig.vue